export default (value, array) => {
  var newArray = array.slice();
  newArray.unshift(value);
  return newArray;
};
